import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { WorkerIncidents } from '@/features/worker-incidents'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-incident-reports/'
)({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: WorkerIncidents,
})
